<template>
  <div class="installMeterRecord">
    <div class="leftStructure" v-if="this.permission">
      <tree
          ref="tree"
          title="客户信息"
          :treeEdit="false"
          :showCheckbox="false"
          :sourceData="sourceData"
          :formatTreeData="jsonTree"
          :defExpandNode="[this.nodeId]"
          @clickTreeNode="clickTree"
          @freshTreeData="getTreeData">
      </tree>
    </div>
    <div class="centerStructure">
      <!--tab切换位置: 默认第一页-->
      <el-tabs v-model="activeName" @tab-click="handleClick" style="height:100%">
        <el-tab-pane label="户用水表" name="first" style="height: 100%">
          <!--户表检索条件-->
          <div class="searchBox">
            <span class="inp">类型：</span>
            <el-input placeholder="请输入内容" v-model.trim="houseHoldForm.keyWord" class="cnotent"
                      clearable>
              <el-select v-model="houseHoldForm.type" slot="prepend" placeholder="请选择">
                <el-option
                    v-for="item in houseHoldForm.typeOfSearch"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-input>
            <span class="inp">对接状态：</span>
            <el-select v-model="houseHoldForm.status">
              <el-option
                  class="wh140"
                  v-for="item in houseHoldForm.statusList"
                  :key="item.id"
                  :label="item.dictionaryName"
                  :value="item.id">
              </el-option>
            </el-select>
            <span class="inp">安装日期：</span>
            <el-date-picker
                v-model="houseHoldForm.dateValue"
                type="daterange"
                :default-time="['00:00:00','23:59:59']"
                :clearable="true"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
            >
            </el-date-picker>
            <el-button type="primary" @click="resSearchButton()" icon="el-icon-search">查询
            </el-button>
            <el-button type="primary" @click="exportRes" icon="el-icon-download"
                       :loading="btnLoadingFlag">导出
            </el-button>
          </div>
          <!--户表表格数据-->
          <el-table
              :data="houseHoldTableData"
              border
              ref="singleResTable"
              style="width: 100%"
              height="calc(93% - 70px)"
          >
            <!--序号-->
            <el-table-column header-align="center" type="index" align="center"
                             width="50"></el-table-column>
            <el-table-column prop="operation"
                             label="操作"
                             width="100px"
                             align="center"
                             header-align="center">
              <template slot-scope="scope">
                <span class="tableicon" @click="houseHoldInfoButton(scope)">查看</span>
                <span class="tableicon" @click="openMap(scope)">定位</span>
              </template>
            </el-table-column>
            <template v-for="item in resTableTitle">
              <el-table-column
                  :fixed="false"
                  :align="item.align"
                  :key="item.prop"
                  :label="item.label"
                  :prop="item.prop"
                  :width="item.width"
                  :header-align="item.halign"
                  show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <!--户表分页数据-->
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="resPageNumber"
              :page-sizes="[20, 50, 100]"
              :page-size="resPageSize"
              layout="total, sizes, prev, pager, next"
              :total="resPageTotal">
          </el-pagination>
          <!--户表弹窗-->
          <el-dialog
              :title="popupHouseHoldTitle"
              :visible.sync="openHouseHoldFlag"
              :close-on-click-modal="false"
              :modal-append-to-body="false"
              width="1020px"
              height="350px"
              @close="closeHouseHoldDialog"
          >
            <div class="formbox">
              <el-form
                  :model="houseHoldPopForm"
                  ref="houseHoldRuleForm"
                  :label-position="labelPosition"
                  label-width="100px"
              >
                <div class="lintit"><i></i><span>用户信息</span></div>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="用户类型：" prop="userType">
                        <el-input class="wh200" v-model="houseHoldPopForm.userType"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="用户姓名：" prop="userName">
                        <el-input class="wh200" v-model="houseHoldPopForm.userName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="用户编号：" prop="userCode">
                        <el-input class="wh200" v-model="houseHoldPopForm.userCode"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="手机号码：" prop="telephone">
                        <el-input class="wh200" v-model="houseHoldPopForm.telephone"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="组织：" prop="orgName">
                        <el-input class="wh200" v-model="houseHoldPopForm.orgName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="小区：" prop="areaName">
                        <el-input class="wh200" v-model="houseHoldPopForm.areaName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="楼栋：" prop="floorName">
                        <el-input class="wh200" v-model="houseHoldPopForm.floorName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="单元：" prop="unitName">
                        <el-input class="wh200" v-model="houseHoldPopForm.unitName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="门牌号：" prop="houseNumber">
                        <el-input class="wh200" v-model="houseHoldPopForm.houseNumber"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="用水类别：" prop="usedWaterTpye">
                        <el-input class="wh200" v-model="houseHoldPopForm.usedWaterType"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="详细地址：" prop="houseMeteraddress">
                        <el-input style="width: 528px;" v-model="houseHoldPopForm.houseMeteraddress"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div class="lintit"><i></i><span>仪表信息</span></div>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="仪表编号：" prop="deviceCode">
                        <el-input class="wh200" v-model="houseHoldPopForm.deviceCode"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表类型：" prop="deviceType">
                        <el-input class="wh200" v-model="houseHoldPopForm.deviceType"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表型号：" prop="deviceModel">
                        <el-input class="wh200" v-model="houseHoldPopForm.deviceModel"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="口径：" prop="diameter">
                        <el-input class="wh200" v-model="houseHoldPopForm.diameter"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="应用名称：" prop="platformName">
                        <el-input class="wh200" v-model="houseHoldPopForm.platformName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="IMEI：" prop="IMEI">
                        <el-input class="wh200" v-model="houseHoldPopForm.IMEI"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="IMSI：" prop="IMSI">
                        <el-input class="wh200" v-model="houseHoldPopForm.IMSI"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="ICCID：" prop="ICCID">
                        <el-input class="wh200" v-model="houseHoldPopForm.ICCID"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装人：" prop="installer">
                        <el-input class="wh200" v-model="houseHoldPopForm.installer"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装时间：" prop="installTime">
                        <el-input class="wh200" v-model="houseHoldPopForm.installTime"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div class="lintit"><i></i><span>图片</span></div>
                <!--上传图片弹窗-->
                <el-row style="display: flex">
                  <div class="imgbox" v-for="img in houseHoldPopForm.houseMeterImgList" :key="img">
                    <div class="demo-image__preview">
                      <el-image
                          style="width: 100px; height: 100px"
                          :src="img"
                          :preview-src-list="[img]">
                      </el-image>
                    </div>
                  </div>
                </el-row>
              </el-form>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="超声流量计" name="second" style="height: 100%">
          <!--非户表检索条件-->
          <div class="searchBox">
            <span class="inp">类型：</span>
            <el-input placeholder="请输入内容" v-model.trim="manageMeterForm.keyWord" class="cnotent"
                      clearable>
              <el-select v-model="manageMeterForm.type" slot="prepend" placeholder="请选择">
                <el-option
                    v-for="item in manageMeterForm.typeOfSearch"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-input>
            <span class="inp">安装日期：</span>
            <el-date-picker
                v-model="manageMeterForm.dateValue"
                type="daterange"
                :default-time="['00:00:00','23:59:59']"
                :clearable="true"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
            >
            </el-date-picker>
            <el-button type="primary" @click="unResSearchButton(2)" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="exportUnRes(2)" icon="el-icon-download"
                       :loading="btnLoadingFlag">导出
            </el-button>
          </div>
          <!--非户表表格数据-->
          <el-table
              :data="manageMeterTableData"
              border
              ref="singleUnResTable"
              style="width: 100%"
              height="calc(93% - 70px)"
          >
            <!--序号-->
            <el-table-column  header-align="center" type="index" align="center"
                             width="50"></el-table-column>
            <el-table-column prop="operation"
                             label="操作"
                             width="100px"
                             align="center"
                             header-align="center">
              <template slot-scope="scope">
                <span class="tableicon" @click="manageMeterInfoButton(scope,2)">查看</span>
                <span class="tableicon" @click="openMap(scope)">定位</span>
              </template>
            </el-table-column>
            <template v-for="item in unResTableTitle">
              <el-table-column
                  :fixed="false"
                  :align="item.align"
                  :key="item.prop"
                  :label="item.label"
                  :prop="item.prop"
                  :width="item.width"
                  :header-align="item.halign"
                  show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <!--非户表分页数据-->
          <el-pagination
              @size-change="handleSizeChangeTwo"
              @current-change="handleCurrentChangeTwo"
              :current-page="unResPageNumber"
              :page-sizes="[20, 50, 100]"
              :page-size="unResPageSize"
              layout="total, sizes, prev, pager, next"
              :total="unResPageTotal">
          </el-pagination>
          <!--超声流量计弹窗-->
          <el-dialog
              :title="popupManageMeterTitle"
              :visible.sync="openFlag"
              :close-on-click-modal="false"
              :modal-append-to-body="false"
              width="1020px"
              height="350px"
              @close="closeDialog"
          >
            <div class="formbox">
              <el-form
                  :model="manageMeterPopForm"
                  ref="ruleForm"
                  :label-position="labelPosition"
                  label-width="100px"
              >
                <div class="lintit"><i></i><span>仪表信息</span></div>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="仪表编号：" prop="deviceCode">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceCode"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表名称：" prop="deviceName">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表型号：" prop="deviceModel">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceModel"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>

                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="口径：" prop="diameter">
                        <el-input class="wh200" v-model="manageMeterPopForm.diameter"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装人：" prop="installer">
                        <el-input class="wh200" v-model="manageMeterPopForm.installer"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装时间：" prop="installTime">
                        <el-input class="wh200" v-model="manageMeterPopForm.installTime"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="详细地址：" prop="address">
                        <el-input style="width: 528px;" v-model="manageMeterPopForm.address"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="备注：" prop="address">
                        <el-input class="wh200" v-model="manageMeterPopForm.remark"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div class="lintit"><i></i><span>图片</span></div>
                <!--上传图片弹窗-->
                <el-row style="display: flex">
                  <div class="imgbox" v-for="img in manageMeterPopForm.imgList" :key="img">
                    <div class="demo-image__preview">
                      <el-image
                          style="width: 100px; height: 100px"
                          :src="img"
                          :preview-src-list="[img]">
                      </el-image>
                    </div>
                  </div>
                </el-row>
              </el-form>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="数据采集器" name="three" style="height: 100%">
          <!--数据采集器检索条件-->
          <div class="searchBox">
            <span class="inp">类型：</span>
            <el-input placeholder="请输入内容" v-model.trim="manageMeterForm.keyWord" class="cnotent"
                      clearable>
              <el-select v-model="manageMeterForm.type" slot="prepend" placeholder="请选择">
                <el-option
                    v-for="item in manageMeterForm.typeOfSearch"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-input>
            <span class="inp">安装日期：</span>
            <el-date-picker
                v-model="manageMeterForm.dateValue"
                type="daterange"
                :default-time="['00:00:00','23:59:59']"
                :clearable="true"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
            >
            </el-date-picker>
            <el-button type="primary" @click="unResSearchButton(3)" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="exportUnRes(3)" icon="el-icon-download"
                       :loading="btnLoadingFlag">导出
            </el-button>
          </div>
          <!--非户表表格数据-->
          <el-table
              :data="manageMeterTableData"
              border
              ref="singleUnResTable"
              style="width: 100%"
              height="calc(93% - 70px)"
          >
            <!--序号-->
            <el-table-column header-align="center" type="index" align="center"
                             width="50"></el-table-column>
            <el-table-column prop="operation"
                             label="操作"
                             width="100px"
                             align="center"
                             header-align="center">
              <template slot-scope="scope">
                <span class="tableicon" @click="manageMeterInfoButton(scope,3)">查看</span>
                <span class="tableicon" @click="openMap(scope)">定位</span>
              </template>
            </el-table-column>
            <template v-for="item in unResTableTitle">
              <el-table-column
                  :fixed="false"
                  :align="item.align"
                  :key="item.prop"
                  :label="item.label"
                  :prop="item.prop"
                  :width="item.width"
                  :header-align="item.halign"
                  show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <!--非户表分页数据-->
          <el-pagination
              @size-change="handleSizeChangeTwo"
              @current-change="handleCurrentChangeTwo"
              :current-page="unResPageNumber"
              :page-sizes="[20, 50, 100]"
              :page-size="unResPageSize"
              layout="total, sizes, prev, pager, next"
              :total="unResPageTotal">
          </el-pagination>
          <!--超声流量计弹窗-->
          <el-dialog
              :title="popupManageMeterTitle"
              :visible.sync="openFlag"
              :close-on-click-modal="false"
              :modal-append-to-body="false"
              width="1020px"
              height="350px"
              @close="closeDialog"
          >
            <div class="formbox">
              <el-form
                  :model="manageMeterPopForm"
                  ref="ruleForm"
                  :label-position="labelPosition"
                  label-width="100px"
              >
                <div class="lintit"><i></i><span>仪表信息</span></div>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="仪表编号：" prop="deviceCode">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceCode"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表名称：" prop="deviceName">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表型号：" prop="deviceModel">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceModel"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>

                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="口径：" prop="diameter">
                        <el-input class="wh200" v-model="manageMeterPopForm.diameter"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装人：" prop="installer">
                        <el-input class="wh200" v-model="manageMeterPopForm.installer"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装时间：" prop="installTime">
                        <el-input class="wh200" v-model="manageMeterPopForm.installTime"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="详细地址：" prop="address">
                        <el-input style="width: 528px;" v-model="manageMeterPopForm.address"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="备注：" prop="address">
                        <el-input class="wh200" v-model="manageMeterPopForm.remark"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div class="lintit"><i></i><span>图片</span></div>
                <!--上传图片弹窗-->
                <el-row style="display: flex">
                  <div class="imgbox" v-for="img in manageMeterPopForm.imgList" :key="img">
                    <div class="demo-image__preview">
                      <el-image
                          style="width: 100px; height: 100px"
                          :src="img"
                          :preview-src-list="[img]">
                      </el-image>
                    </div>
                  </div>
                </el-row>
              </el-form>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="户用热表" name="four" style="height: 100%">
          <!--非户表检索条件-->
          <div class="searchBox">
            <span class="inp">类型：</span>
            <el-input placeholder="请输入内容" v-model.trim="manageMeterForm.keyWord" class="cnotent"
                      clearable>
              <el-select v-model="manageMeterForm.type" slot="prepend" placeholder="请选择">
                <el-option
                    v-for="item in manageMeterForm.typeOfSearch"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-input>
            <span class="inp">安装日期：</span>
            <el-date-picker
                v-model="manageMeterForm.dateValue"
                type="daterange"
                :default-time="['00:00:00','23:59:59']"
                :clearable="true"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
            >
            </el-date-picker>
            <el-button type="primary" @click="unResSearchButton(4)" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="exportUnRes(4)" icon="el-icon-download"
                       :loading="btnLoadingFlag">导出
            </el-button>
          </div>
          <!--非户表表格数据-->
          <el-table
              :data="manageMeterTableData"
              border
              ref="singleUnResTable"
              style="width: 100%"
              height="calc(93% - 70px)"
          >
            <!--序号-->
            <el-table-column header-align="center" type="index" align="center"
                             width="50"></el-table-column>
            <el-table-column prop="operation"
                             label="操作"
                             width="100px"
                             align="center"
                             header-align="center">
              <template slot-scope="scope">
                <span class="tableicon" @click="manageMeterInfoButton(scope ,4)">查看</span>
                <span class="tableicon" @click="openMap(scope)">定位</span>
              </template>
            </el-table-column>
            <template v-for="item in unResTableTitle">
              <el-table-column
                  :fixed="false"
                  :align="item.align"
                  :key="item.prop"
                  :label="item.label"
                  :prop="item.prop"
                  :width="item.width"
                  :header-align="item.halign"
                  show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <!--非户表分页数据-->
          <el-pagination
              @size-change="handleSizeChangeTwo"
              @current-change="handleCurrentChangeTwo"
              :current-page="unResPageNumber"
              :page-sizes="[20, 50, 100]"
              :page-size="unResPageSize"
              layout="total, sizes, prev, pager, next"
              :total="unResPageTotal">
          </el-pagination>
          <!--超声流量计弹窗-->
          <el-dialog
              :title="popupManageMeterTitle"
              :visible.sync="openFlag"
              :close-on-click-modal="false"
              :modal-append-to-body="false"
              width="1020px"
              height="350px"
              @close="closeDialog"
          >
            <div class="formbox">
              <el-form
                  :model="manageMeterPopForm"
                  ref="ruleForm"
                  :label-position="labelPosition"
                  label-width="100px"
              >
                <div class="lintit"><i></i><span>仪表信息</span></div>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="仪表编号：" prop="deviceCode">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceCode"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表名称：" prop="deviceName">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表型号：" prop="deviceModel">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceModel"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>

                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="口径：" prop="diameter">
                        <el-input class="wh200" v-model="manageMeterPopForm.diameter"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装人：" prop="installer">
                        <el-input class="wh200" v-model="manageMeterPopForm.installer"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装时间：" prop="installTime">
                        <el-input class="wh200" v-model="manageMeterPopForm.installTime"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="详细地址：" prop="address">
                        <el-input style="width: 528px;" v-model="manageMeterPopForm.address"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="备注：" prop="address">
                        <el-input class="wh200" v-model="manageMeterPopForm.remark"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div class="lintit"><i></i><span>图片</span></div>
                <!--上传图片弹窗-->
                <el-row style="display: flex">
                  <div class="imgbox" v-for="img in manageMeterPopForm.imgList" :key="img">
                    <div class="demo-image__preview">
                      <el-image
                          style="width: 100px; height: 100px"
                          :src="img"
                          :preview-src-list="[img]">
                      </el-image>
                    </div>
                  </div>
                </el-row>
              </el-form>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="管理热表" name="five" style="height: 100%">
          <!--非户表检索条件-->
          <div class="searchBox">
            <span class="inp">类型：</span>
            <el-input placeholder="请输入内容" v-model.trim="manageMeterForm.keyWord" class="cnotent"
                      clearable>
              <el-select v-model="manageMeterForm.type" slot="prepend" placeholder="请选择">
                <el-option
                    v-for="item in manageMeterForm.typeOfSearch"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-input>
            <span class="inp">安装日期：</span>
            <el-date-picker
                v-model="manageMeterForm.dateValue"
                type="daterange"
                :default-time="['00:00:00','23:59:59']"
                :clearable="true"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
            >
            </el-date-picker>
            <el-button type="primary" @click="unResSearchButton(5)" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="exportUnRes(5)" icon="el-icon-download"
                       :loading="btnLoadingFlag">导出
            </el-button>
          </div>
          <!--非户表表格数据-->
          <el-table
              :data="manageMeterTableData"
              border
              ref="singleUnResTable"
              style="width: 100%"
              height="calc(93% - 70px)"
          >
            <!--序号-->
            <el-table-column header-align="center" type="index" align="center"
                             width="50"></el-table-column>
            <el-table-column prop="operation"
                             label="操作"
                             width="100px"
                             align="center"
                             header-align="center">
              <template slot-scope="scope">
                <span class="tableicon" @click="manageMeterInfoButton(scope ,5)">查看</span>
                <span class="tableicon" @click="openMap(scope)">定位</span>
              </template>
            </el-table-column>
            <template v-for="item in unResTableTitle">
              <el-table-column
                  :fixed="false"
                  :align="item.align"
                  :key="item.prop"
                  :label="item.label"
                  :prop="item.prop"
                  :width="item.width"
                  :header-align="item.halign"
                  show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <!--非户表分页数据-->
          <el-pagination
              @size-change="handleSizeChangeTwo"
              @current-change="handleCurrentChangeTwo"
              :current-page="unResPageNumber"
              :page-sizes="[20, 50, 100]"
              :page-size="unResPageSize"
              layout="total, sizes, prev, pager, next"
              :total="unResPageTotal">
          </el-pagination>
          <!--超声流量计弹窗-->
          <el-dialog
              :title="popupManageMeterTitle"
              :visible.sync="openFlag"
              :close-on-click-modal="false"
              :modal-append-to-body="false"
              width="1020px"
              height="350px"
              @close="closeDialog"
          >
            <div class="formbox">
              <el-form
                  :model="manageMeterPopForm"
                  ref="ruleForm"
                  :label-position="labelPosition"
                  label-width="100px"
              >
                <div class="lintit"><i></i><span>仪表信息</span></div>
                <el-row>
                  <el-col :span="8">
                    <div class="grid-content bg-purple">
                      <el-form-item label="仪表编号：" prop="deviceCode">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceCode"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表名称：" prop="deviceName">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceName"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="仪表型号：" prop="deviceModel">
                        <el-input class="wh200" v-model="manageMeterPopForm.deviceModel"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>

                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="口径：" prop="diameter">
                        <el-input class="wh200" v-model="manageMeterPopForm.diameter"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装人：" prop="installer">
                        <el-input class="wh200" v-model="manageMeterPopForm.installer"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="安装时间：" prop="installTime">
                        <el-input class="wh200" v-model="manageMeterPopForm.installTime"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="详细地址：" prop="address">
                        <el-input style="width: 528px;" v-model="manageMeterPopForm.address"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="grid-content bg-purple-light">
                      <el-form-item label="备注：" prop="address">
                        <el-input class="wh200" v-model="manageMeterPopForm.remark"
                                  disabled></el-input>
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <div class="lintit"><i></i><span>图片</span></div>
                <!--上传图片弹窗-->
                <el-row style="display: flex">
                  <div class="imgbox" v-for="img in manageMeterPopForm.imgList" :key="img">
                    <div class="demo-image__preview">
                      <el-image
                          style="width: 100px; height: 100px"
                          :src="img"
                          :preview-src-list="[img]">
                      </el-image>
                    </div>
                  </div>
                </el-row>
              </el-form>
            </div>
          </el-dialog>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!--地图弹窗-->
    <el-dialog :title='maptitle'
               :visible.sync="opendiamapflag"
               :close-on-click-modal="true"
               :modal-append-to-body="false"
               width="1000px">
      <!--引入地图子组件-->
      <gdmap style="height: 500px" @transferFromGdMap='setUpLngLat' :areaName="searchAreaName"
             v-bind:FatherLngLat="FatherLngLat"
             :key="timer"></gdmap>
    </el-dialog>
  </div>
</template>

<!--js部分-->
<script>

import {Mixins} from '@/config/mixins/mixins'
import {$http} from '@/config/api/axios'
import ColumnDrag from "@/components/common/ColumnDrag"
import Tree from "@/components/common/Tree";
import {set_local_cache, get_local_cache, remove_local_cache, get_session_cache} from "@/config/cache/cache.js"
import {IsInteger, IsNull} from "@/config/validate/common";
import gdmap from "@/components/common/GdMap";

export default {
  name: "installMeterRecord",
  mixins: [Mixins],  //混入公共方法,慎用.
  components: {
    Tree,
    ColumnDrag,  //表格字段拖拽调换顺序
    gdmap  //高德地图
  },
  data() {
    return {

      //地图相关
      //地图
      maptitle: '经纬度信息',//地图弹窗标题
      opendiamapflag: false,//地图弹窗是否打开
      //控制重新渲染子组件
      timer: '',
      //经纬度
      FatherLngLat: null,
      isShow: false,
      searchAreaName: "",

      permission: false,
      sourceData: [],
      jsonTree: {
        id: "id",
        label: 'customerName',
        pcode: 'parentCode',
        code: 'code',
      },
      treeExpandNode: [],
      nodeId: '',
      //组织树节点查询条件
      orgNode: {
        code: '',
        isStreet: '',
        nodeType: '',
        id: ''
      },
      //tab切换标志
      tabTurnFlag1: 0,
      tabTurnFlag2: 0,
      tabTurnFlag3: 0,
      tabTurnFlag4: 0,
      tabTurnFlag5: 0,
      //加载完数据之后再渲染数据
      isOver: false,
      //按钮Loading标识
      btnLoadingFlag: false,
      //标签
      activeName: 'first',
      //路径
      host: location.protocol + '//' + window.location.host + this.prefix + '/',

      popupManageMeterTitle: '',
      popupHouseHoldTitle: '户表详情',
      //窗体打开标志
      openFlag: false,
      // 户表详情弹窗打开标志
      openHouseHoldFlag: false,
      // 超声流量计表单
      manageMeterPopForm: {
        deviceCode: '',
        deviceName: '',
        deviceModel: '',
        diameter: '',
        address: '',
        installer: '',
        installTime: '',
        remark: '',
        imgList: [],
      },
      // 户表弹窗表单
      houseHoldPopForm: {
        // 用户信息
        userType: '',
        userName: '',
        userCode: '',
        telephone: '',
        orgName: '',
        areaName: '',
        floorName: '',
        unitName: '',
        houseNumber: '',
        houseMeteraddress: '',
        usedWaterType: '',
        // 仪表信息
        deviceCode: '',
        deviceType: '',
        deviceModel: '',
        diameter: '',
        platformName: '',
        IMEI: '',
        IMSI: '',
        ICCID: '',
        installer: '',
        installTime: '',
        houseMeterImgList: [],
        imgUrl: ''
      },
      houseHoldForm: {
        startTime: '', //开始时间
        endTime: '', //结束时间
        dateValue: '',
        statusList: [
          {"id": 0, "dictionaryName": "全部"},
          {"id": 1, "dictionaryName": "是"},
          {"id": 2, "dictionaryName": "否"},
        ],
        status: 0,
        keyWord: '',
        type: 1,
        typeOfSearch: [
          {
            value: 1,
            label: '仪表编号'
          }, {
            value: 2,
            label: '用户姓名'
          }, {
            value: 3,
            label: '安装人'
          }],
      },
      //户表表格数据
      houseHoldTableData: [],
      //户表表头
      resTableTitle: [
        {prop: "userType", label: '用户类型', width: "80px", align: "center", halign: "center"},
        {prop: "userName", label: '用户姓名', width: "140px", align: "left", halign: "center"},
        {prop: "userCode", label: '用户编号', width: "140px", align: "left", halign: "center"},
        {prop: "deviceCode", label: '仪表编号', width: "140px", align: "left", halign: "center"},
        {prop: "deviceType", label: '仪表类型', width: "100px", align: "center", halign: "center"},
        {prop: "dockingStatus", label: '对接状态', width: "80px", align: "center", halign: "center"},
        {prop: "installer", label: '安装人', width: "100px", align: "center", halign: "center"},
        {prop: "installTime", label: '安装时间', width: "160px", align: "center", halign: "center"},
        {prop: "address", label: '详细地址', width: "", align: "left", halign: "center"},
        {prop: "remark", label: '备注', width: "150px", align: "left", halign: "center"},
      ],
      resExportTitle: [
        {prop: "userType", label: '用户类型',},
        {prop: "userName", label: '用户姓名',},
        {prop: "userCode", label: '用户编号',},
        {prop: "deviceCode", label: '仪表编号',},
        {prop: "deviceType", label: '仪表类型',},
        {prop: "model", label: '型号',},
        {prop: "diameter", label: '口径',},
        {prop: "telephone", label: '手机号',},
        {prop: "", label: '组织名称',},
        {prop: "", label: '小区',},
        {prop: "", label: '楼栋',},
        {prop: "", label: '单元',},
        {prop: "", label: '门牌',},
        {prop: "dockingStatus", label: '对接状态',},
        {prop: "installer", label: '安装人',},
        {prop: "installTime", label: '安装时间',},
        {prop: "address", label: '详细地址',},
        {prop: "province", label: '省份',},
        {prop: "city", label: '市',},
        {prop: "area", label: '区',},
        {prop: "longitude", label: '经度',},
        {prop: "latitude", label: '纬度',},
        {prop: "remark", label: '备注',},
      ],
      //户表分页数据
      resPageSize: 20, //条数
      resPageNumber: 1,
      resPageTotal: 0, //总页数

      /**************************************户表/非户表分割线********************************************/

      //超声流量计检索条件
      manageMeterForm: {
        startTime: '', //开始时间
        endTime: '', //结束时间
        dateValue: '',
        keyWord: '',
        type: '1',
        typeOfSearch: [
          {
            value: '1',
            label: '仪表编号'
          }, {
            value: '2',
            label: '仪表名称'
          }, {
            value: '3',
            label: '安装人'
          }],
      },
      //表单域标签的位置，值为 left 或者 right 时，则需要设置 label-width
      labelPosition: 'right',
      //非户表表格数据
      manageMeterTableData: [],
      //非户表表头
      unResTableTitle: [
        {prop: "deviceCode", label: '仪表编号', width: "140px", align: "left", halign: "center"},
        {prop: "deviceName", label: '仪表名称', width: "220px", align: "left", halign: "center"},
        {prop: "deviceModel", label: '仪表型号', width: "110px", align: "center", halign: "center"},
        {prop: "diameter", label: '口径', width: "100px", align: "center", halign: "center"},
        {prop: "address", label: '详细地址', width: "", align: "left", halign: "center"},
        {prop: "installer", label: '安装人', width: "110px", align: "center", halign: "center"},
        {prop: "installTime", label: '安装时间', width: "170px", align: "center", halign: "center"},
        {prop: "remark", label: '备注', width: "200px", align: "left", halign: "center"},
      ],
      //非户表导出表头
      unResExportTitle: [
        {prop: "deviceCode", label: '仪表编号',},
        {prop: "deviceName", label: '仪表名称',},
        {prop: "deviceModel", label: '仪表型号',},
        {prop: "diameter", label: '口径',},
        {prop: "address", label: '详细地址',},
        {prop: "installer", label: '安装人',},
        {prop: "installTime", label: '安装时间',},
        {prop: "province", label: '省份',},
        {prop: "city", label: '市',},
        {prop: "area", label: '区',},
        {prop: "longitude", label: '经度',},
        {prop: "latitude", label: '纬度',},
        {prop: "remark", label: '备注',},
      ],
      //非户表分页数据
      unResPageSize: 20, //条数
      unResPageNumber: 1,
      unResPageTotal: 0, //总页数
    };
  },
  //监听部分
  watch: {},
  //方法部分
  methods: {


    //设置经纬度弹窗
    openMap(scope) {
      this.timer = new Date().getTime();
      this.opendiamapflag = true;
      this.maptitle = "经纬度信息";
      this.FatherLngLat = scope.row.longitudeAndLatitude;
    },

    //赋值经纬度和地理位置信息
    setUpLngLat(mapData) {
      this.opendiamapflag = false;
      //if (mapData != null) {
        //经纬度
        // this.customerDialogForm.longitudeAndLatitude = mapData.lngLat;
        //地理位置信息
        // if (mapData.address != null && mapData.address !== "") {
        //   this.customerDialogForm.address = mapData.address;
        // }
     // }
    },

    //获取树
    getTreeData() {
      this.sourceData = [];
      // this.selfLoadingOpen('.installMeterRecord');
      $http("get", "/wechat/customer/getCustomerTree").then((res) => {
        if (res.status === 'SUCCESS') {
          this.sourceData = Object.freeze(res.data);
        } else {
          this.sourceData = [];
        }
        this.selfLoadingClose();
      });
    },
    //点击树
    clickTree(data) {
      if (this.orgNode.id !== data.id) {
        this.tabTurnFlag1 = 0;
        // this.tabTurnFlag2 = 0;
        // this.tabTurnFlag3 = 0;
        // this.tabTurnFlag4 = 0;
        // this.tabTurnFlag5 = 0;
      }
      this.orgNode.id = data.id;
      this.nodeId = data.id;
      if (this.activeName == 'first') {
        this.getResInfo();
        this.tabTurnFlag1 = 1;
      }
      if (this.activeName == 'second') {
        this.getUnResInfo(2);
      }
      if (this.activeName == 'three') {
        this.getUnResInfo(3);
      }
      if (this.activeName == 'four') {
        this.getUnResInfo(4);
      }
      if (this.activeName == 'five') {
        this.getUnResInfo(5);
      }
    },
    //获取当前用户权限

    getPermission() {
      let loginType = get_session_cache('loginType');
      //为平台管理员时  左侧需要显示客户树
      if ( loginType=== '1008001') {
        this.permission = true;
        this.getTreeData();
      } else if(loginType === '1008002'){
        this.permission = false;
        let cus = "consumer_"+JSON.parse(get_local_cache("tokenUser")).tokenUserId;
        this.orgNode.id = JSON.parse(get_local_cache(cus)).userId;
      } else {
        this.permission = false;
        this.orgNode.id = JSON.parse(get_local_cache("tokenUser")).tokenUserCustomerId;
      }
    },
    //关闭弹窗
    closeDialog() {
      this.$refs['ruleForm'].resetFields(); //清空表单
    },
    closeHouseHoldDialog() {
      this.$refs['houseHoldRuleForm'].resetFields(); //清空表单
    },
    //户表点击详情按钮
    houseHoldInfoButton(scope) {
      let param = {};
      param.deviceId = scope.row.id;
      $http("get", "installMeterRecord/getDeviceDetailInfoById", param)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              this.houseHoldPopForm.houseMeterImgList = [];
              this.houseHoldPopForm.userType = res.data.user.userType;
              this.houseHoldPopForm.userName = res.data.user.userName;
              this.houseHoldPopForm.userCode = res.data.user.userCode;
              this.houseHoldPopForm.telephone = res.data.user.telephone;
              this.houseHoldPopForm.orgName = res.data.user.orgName;
              this.houseHoldPopForm.areaName = res.data.user.areaName;
              this.houseHoldPopForm.floorName = res.data.user.floorName;
              this.houseHoldPopForm.unitName = res.data.user.unitName;
              this.houseHoldPopForm.houseNumber = res.data.user.houseNumber;
              this.houseHoldPopForm.houseMeteraddress = res.data.user.houseMeteraddress;
              this.houseHoldPopForm.usedWaterType = res.data.user.usedWaterType;

              this.houseHoldPopForm.deviceCode = res.data.device.deviceCode;
              this.houseHoldPopForm.deviceType = res.data.device.deviceType;
              this.houseHoldPopForm.deviceModel = res.data.device.deviceModel;
              this.houseHoldPopForm.diameter = res.data.device.diameter;
              this.houseHoldPopForm.platformName = res.data.device.platformName;
              this.houseHoldPopForm.IMEI = res.data.device.IMEI;
              this.houseHoldPopForm.IMSI = res.data.device.IMSI;
              this.houseHoldPopForm.ICCID = res.data.device.ICCID;
              this.houseHoldPopForm.installer = res.data.device.installer;
              this.houseHoldPopForm.installTime = res.data.device.installTime;
              //图片回显
              let attachmentList = res.data.pic;
              for (let i = 0; i < attachmentList.length; i++) {
                let aa = attachmentList[i].attachmentUrl;
                this.houseHoldPopForm.houseMeterImgList.push(this.host + aa);
              }
              this.openHouseHoldFlag = true;
            } else {
              this.msgerror(res.message);
            }
          });
    },
    //超声流量计点击详情按钮
    manageMeterInfoButton(scope ,deviceType) {
      if (deviceType === 2){
        this.popupManageMeterTitle = "超声流量计详情";
      }
      else if (deviceType === 3){
        this.popupManageMeterTitle = "数据采集器详情";
      }
      else if (deviceType === 4){
        this.popupManageMeterTitle = "户用热表详情";
      }
      else if (deviceType === 5){
        this.popupManageMeterTitle = "管理热表详情";
      }
      let param = {};
      param.deviceId = scope.row.id;
      $http("get", "installMeterRecord/getManageDeviceDetailInfoById", param)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              this.manageMeterPopForm.deviceCode = res.data.device.deviceCode;
              this.manageMeterPopForm.deviceName = res.data.device.deviceName;
              this.manageMeterPopForm.deviceModel = res.data.device.deviceModel;
              this.manageMeterPopForm.diameter = res.data.device.diameter;
              this.manageMeterPopForm.address = res.data.device.address;
              this.manageMeterPopForm.installer = res.data.device.installer;
              this.manageMeterPopForm.installTime = res.data.device.installTime;
              this.manageMeterPopForm.remark = res.data.device.remark;
              this.manageMeterPopForm.imgList = [];
              //图片回显
              let attachmentList = res.data.pic;
              for (let i = 0; i < attachmentList.length; i++) {
                let aa = attachmentList[i].attachmentUrl;
                this.manageMeterPopForm.imgList.push(this.host + aa);
              }
              this.openFlag = true; //打开弹窗
            } else {
              this.msgerror(res.message);
            }
          });
    },
    //tab标签页切换事件
    handleClick(tab, event) {
      let _this = this;
      let tabName = tab.paneName;
      if (tabName === 'first') {
        this.activeName = 'first';
        setTimeout(() => {
          this.$refs.singleResTable.doLayout();
        }, 10);
        if (this.tabTurnFlag1 === 0) {
          this.getResInfo();
          _this.tabTurnFlag1 = 1;
        }
      } else if (tabName === 'second') {
        this.activeName = 'second';
        setTimeout(() => {
          this.$refs.singleUnResTable.doLayout();
        }, 10);
        this.getUnResInfo(2);
      } else if (tabName === 'three') {
        this.activeName = 'three';
        setTimeout(() => {
          this.$refs.singleUnResTable.doLayout();
        }, 10);
        this.getUnResInfo(3);

      } else if (tabName === 'four') {
        this.activeName = 'four';
        setTimeout(() => {
          this.$refs.singleUnResTable.doLayout();
        }, 10);

        this.getUnResInfo(4);

      } else if (tabName === 'five') {
        this.activeName = 'five';
        setTimeout(() => {
          this.$refs.singleUnResTable.doLayout();
        }, 10);
        this.getUnResInfo(5);
      }
    },
    /******************************************公共方法分割线*************************************/

    //户表查询按钮
    resSearchButton() {
      this.handleCurrentChange(1);
    },
    // 户表查询
    getResInfo() {
      this.selfLoadingOpen('.installMeterRecord');
      if (this.houseHoldForm.dateValue !== "" && this.houseHoldForm.dateValue != null) {
        this.houseHoldForm.startTime = Math.floor(this.houseHoldForm.dateValue[0] / 1000);
        this.houseHoldForm.endTime = Math.ceil(this.houseHoldForm.dateValue[1] / 1000)
      } else {
        this.houseHoldForm.startTime = null;
        this.houseHoldForm.endTime = null;
      }
      this.houseHoldTableData = [];
      this.isOver = false;
      let _this = this;
      let params = {};
      params.customerId = this.orgNode.id;
      params.startTime = _this.houseHoldForm.startTime;
      params.endTime = _this.houseHoldForm.endTime;
      params.dockingStatus = _this.houseHoldForm.status;
      params.type = _this.houseHoldForm.type;
      params.content = _this.houseHoldForm.keyWord;
      params.pageSize = _this.resPageSize;
      params.pageNumber = _this.resPageNumber;
      $http("get", "installMeterRecord/listInstallMeterRecord", params).then((res) => {
        if (res.status === 'SUCCESS') {
          for (let i = 0; i < res.data.length; i++) {
            _this.houseHoldTableData.push(res.data[i])
          }
          _this.resPageTotal = res.count;
        } else if (res.status === 'NORESOURCES') {
          _this.houseHoldTableData = [];
          _this.resPageTotal = res.count;
        } else {
          this.msgerror(res.message);
        }
        _this.selfLoadingClose(); //关闭遮罩
        _this.isOver = true;
      });
    },
    //户表导出按钮
    exportRes() {
      let _this = this;
      if (this.houseHoldForm.dateValue !== "" && this.houseHoldForm.dateValue != null) {
        this.houseHoldForm.startTime = Math.floor(this.houseHoldForm.dateValue[0] / 1000);
        this.houseHoldForm.endTime = Math.ceil(this.houseHoldForm.dateValue[1] / 1000)
      } else {
        this.houseHoldForm.startTime = null;
        this.houseHoldForm.endTime = null;
      }
      let params = {};
      params.customerId = this.orgNode.id;
      params.startTime = _this.houseHoldForm.startTime;
      params.endTime = _this.houseHoldForm.endTime;
      params.dockingStatus = _this.houseHoldForm.status;
      params.type = _this.houseHoldForm.type;
      params.content = _this.houseHoldForm.keyWord;
      params.title = encodeURIComponent(JSON.stringify(this.resExportTitle));
      this.btnLoadingFlag = true;
      $http("get", "installMeterRecord/exportInstallMeterRecordForHouseHold", params)
          .then((result) => {
            this.btnLoadingFlag = false;
            if (result.status === "SUCCESS") {
              window.location.href = _this.host + result.data;
            } else {
              this.msgerror(result.message);
            }
          })
    },
    //户表切换页面方法
    handleSizeChange(val) {
      this.resPageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.resPageNumber = val;
      this.getResInfo();
    },

    /**************************************户表/非户表分割线********************************************/

    //非户表查询按钮
    unResSearchButton(deviceType) {
      this.handleCurrentChangeTwo(1, deviceType);
    },
    //超声流量计查询列表
    getUnResInfo(deviceType) {
      this.selfLoadingOpen('.installMeterRecord');
      this.manageMeterTableData = [];
      let _this = this;
      if (this.manageMeterForm.dateValue !== "" && this.manageMeterForm.dateValue != null) {
        this.manageMeterForm.startTime = Math.floor(this.manageMeterForm.dateValue[0] / 1000);
        this.manageMeterForm.endTime = Math.ceil(this.manageMeterForm.dateValue[1] / 1000)
      } else {
        this.manageMeterForm.startTime = null;
        this.manageMeterForm.endTime = null;
      }
      let params = {};
      params.customerId = this.orgNode.id;
      params.startTime = _this.manageMeterForm.startTime;
      params.endTime = _this.manageMeterForm.endTime;
      params.deviceType = deviceType;
      params.type = _this.manageMeterForm.type;
      params.content = _this.manageMeterForm.keyWord;
      params.pageSize = _this.unResPageSize;
      params.pageNumber = _this.unResPageNumber;
      $http("get", "installMeterRecord/listInstallMeterRecordForManage", params).then((res) => {
        if (res.status === 'SUCCESS') {
          for (let i = 0; i < res.data.length; i++) {
            _this.manageMeterTableData.push(res.data[i])
          }
          _this.unResPageTotal = res.count;
        } else if (res.status === 'NORESOURCES') {
          _this.manageMeterTableData = [];
          _this.unResPageTotal = res.count;
        } else {
          _this.msgerror(res.message);
        }
        this.selfLoadingClose(); //关闭遮罩
      });
    },


    //非户表导出按钮
    exportUnRes(deviceType) {
      let _this = this;
      if (this.manageMeterForm.dateValue !== "" && this.manageMeterForm.dateValue != null) {
        this.manageMeterForm.startTime = Math.floor(this.manageMeterForm.dateValue[0] / 1000);
        this.manageMeterForm.endTime = Math.ceil(this.manageMeterForm.dateValue[1] / 1000)
      } else {
        this.manageMeterForm.startTime = null;
        this.manageMeterForm.endTime = null;
      }
      let params = {};
      params.customerId = this.orgNode.id;
      params.startTime = _this.manageMeterForm.startTime;
      params.endTime = _this.manageMeterForm.endTime;
      params.deviceType = deviceType;
      params.type = _this.manageMeterForm.type;
      params.content = _this.manageMeterForm.keyWord;
      params.title = encodeURIComponent(JSON.stringify(this.unResExportTitle));
      this.btnLoadingFlag = true;
      $http("get", "installMeterRecord/exportInstallMeterRecordForManage", params)
          .then((result) => {
            this.btnLoadingFlag = false;
            if (result.status === "SUCCESS") {
              window.location.href = this.host + result.data;
            } else {
              this.msgerror(result.message);
            }
          })
    },
    //非户表切换页面方法
    handleSizeChangeTwo(val) {
      this.unResPageSize = val;
      this.handleCurrentChangeTwo(1);
    },
    handleCurrentChangeTwo(val, deviceType) {
      this.unResPageNumber = val;
      if (IsNull(deviceType)) {
        switch (this.activeName) {
          case 'first':
            deviceType = 1;
            break;
          case 'second':
            deviceType = 2;
            break;
          case 'three':
            deviceType = 3;
            break;
          case 'four':
            deviceType = 4;
            break;
          case 'five':
            deviceType = 5;
            break;
        }
      }
      this.getUnResInfo(deviceType);
    },
  },

  //页面创建时候请求的方法.
  created() {
    this.getPermission();
    this.getResInfo();
  },
  activated() {
    if (!!this.$refs['singleResTable']) {
      this.$refs.singleResTable.doLayout();
    }
    if (!!this.$refs['singleUnResTable']) {
      this.$refs.singleUnResTable.doLayout();
    }
  },
}
</script>
<!--css部分-->
<style lang="less">
.installMeterRecord {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;

  .formbox {
    padding-right: 20px;
    max-height: 611px;
    overflow-y: auto;
  }

  /*Tab页切换样式调整*/

  .el-tabs__content {
    height: 100% !important;
    overflow: hidden;
    position: relative;
  }

  .centerStructure {
    padding-top: 4px;
  }

  .el-pagination {
    text-align: right;
    margin-top: 10px;
  }

  .dateWidth {
    width: 140px !important;
  }

  .cnotent {
    width: 281px;
  }

  .imgbox {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
</style>